
/*************  TOP-MENU SET ACTIVE /*************/



$(function () {
  if (location.pathname != "/") {
    // first set active to all that match url
    $(".main-navbar .navbar-nav .check-active a[href='" + location.href + "']").each( function(){
      var url = $(this).attr("href");
      if ($(this).hasClass("dropdown-item")) {
        $(this).parent().addClass('active');
      } else {
        $(this).addClass('active');
      }
    });
    // then set parent dropdown-item to active
    $(".main-navbar .active").each( function(){

      $(this).closest(".dropdown").addClass('active');
      $(this).parents("li.nav-item").addClass('active');
    });
  }
});

/*************  SUBNAV PRESERVE SCROLL POSITION  /*************/

$(function () {
  $(".subnavigation").on("click", "a.subnavigation-link", function () {
    try {
      sessionStorage.setItem("subnavScrollY", String(window.scrollY || window.pageYOffset || 0));
      sessionStorage.setItem("subnavScrollPath", location.pathname);
      var wasSticky = $(".main-navbar").last().hasClass("now-sticky") ? "1" : "0";
      sessionStorage.setItem("subnavWasSticky", wasSticky);
      var subnavWasSticky = $(".subnavigation").hasClass("is-sticky") ? "1" : "0";
      sessionStorage.setItem("subnavWasSticky", subnavWasSticky);
    } catch (e) {}
  });

  try {
    var storedY = sessionStorage.getItem("subnavScrollY");
    if (storedY !== null) {
      var y = parseInt(storedY, 10);
      if (!isNaN(y)) {
        var wasSticky = sessionStorage.getItem("subnavWasSticky") === "1";
        var subnavWasSticky = sessionStorage.getItem("subnavWasSticky") === "1";
        var offset = wasSticky ? 48 : 0;
        if (wasSticky && subnavWasSticky) {
          offset = -48;
        }
        var root = document.documentElement;
        var previousBehavior = root.style.scrollBehavior;
        root.style.scrollBehavior = "auto";
        requestAnimationFrame(function () {
          var maxY = y + offset;
          var subnavEl = document.querySelector(".subnavigation");
          if (subnavEl) {
            var subnavTop = subnavEl.getBoundingClientRect().top + window.pageYOffset;
            maxY = Math.min(maxY, subnavTop + offset);
          }
          window.scrollTo({ top: maxY, left: 0, behavior: "auto" });
          root.style.scrollBehavior = previousBehavior;
        });
      }
      sessionStorage.removeItem("subnavScrollY");
      sessionStorage.removeItem("subnavScrollPath");
      sessionStorage.removeItem("subnavWasSticky");
      sessionStorage.removeItem("subnavWasSticky");
    }
  } catch (e) {}
});

/*************  SUBNAV MOBILE TOGGLE  /*************/

$(function () {
  var subnav = document.querySelector(".subnavigation");
  if (!subnav) {
    return;
  }
  var links = subnav.querySelectorAll(".subnavigation-link");

  var toggle = subnav.querySelector(".subnavigation-toggle");
  if (!toggle) {
    return;
  }

  var shouldCollapseMobileSubnav = links.length > 6;
  if (shouldCollapseMobileSubnav) {
    subnav.classList.add("has-many-links");
  }
  var hasOddLinks = links.length % 2 === 1;
  if (hasOddLinks) {
    subnav.classList.add("has-odd-links");
  }

  var activeIndex = Array.prototype.findIndex.call(links, function (link) {
    return link.classList.contains("is-active");
  });

  var setExpandedState = function (expanded) {
    subnav.classList.toggle("is-expanded", expanded);
    var showMobileFiller = hasOddLinks && (!subnav.classList.contains("has-many-links") || expanded);
    subnav.classList.toggle("show-mobile-filler", showMobileFiller);
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    var collapsedLabel = toggle.getAttribute("data-label-collapsed") || "Show all sections";
    var expandedLabel = toggle.getAttribute("data-label-expanded") || "Show fewer sections";
    toggle.textContent = expanded ? expandedLabel : collapsedLabel;
  };

  // Keep active item visible by default when it would otherwise be hidden.
  if (subnav.classList.contains("has-many-links") && activeIndex >= 4) {
    setExpandedState(true);
  } else {
    setExpandedState(false);
  }

  toggle.addEventListener("click", function () {
    setExpandedState(!subnav.classList.contains("is-expanded"));
  });
});

/*************  TOP-MENU LEVEL 2 and 3  /*************/

$(function() {
  $('.main-navbar').on('click', 'a.expandable', function(){
    if ($(this).hasClass('collapsed')) {
      $(this).find(".fa-angle-down").hide();
      $(this).find(".fa-angle-up").show();
      $(this).removeClass('collapsed');
      $(this).next("ul").addClass('show');
    } else {
      $(this).find(".fa-angle-down").show();
      $(this).find(".fa-angle-up").hide();
      $(this).addClass('collapsed');
      $(this).next("ul").removeClass('show');
    }
    return false;
  });
});


/*************  TOP-MENU SHOW SEARCH  /*************/



$(function () {
  $(".main-navbar .search-trigger").click(function(e){
    $(".main-navbar .search-form-wrapper").toggle();
    $(".main-navbar .search-form-wrapper input").focus();
    return false;
  });
});

$(function () {
  $(".top-lang-picker .search-trigger2").click(function(e){
    $(".main-navbar .search-form-wrapper").toggle();
    $(".main-navbar .search-form-wrapper input").focus();
    return false;
  });
});


/*************  TOP-MENU SET NOW-STICKY  /*************/



$(function () {

  var navbar = $(".main-navbar").last();
  var initialNavbarStartPos = 1;
  var initialNavbarEndPos = initialNavbarStartPos + navbar.outerHeight(true);
  $(window).on('scroll', () => {
    var winPos = $(window).scrollTop();
    //console.log("----");

    //console.log($(window).scrollTop());
   // console.log(initialNavbarStartPos);
    if (winPos > initialNavbarEndPos + 245) {
      if ($(".main-navbar").hasClass("now-sticky") == false) {
        $("body>.bridge").hide();
        $(".main-navbar").css("opacity", "0");
        //$(".main-navbar").hide();
        $(".main-navbar").removeClass("scrolled-back-to-top");
        $(".main-navbar").addClass("now-sticky");
        //$(".boj").addClass("now-sticky");
        $( ".main-navbar" ).fadeTo( 250, 1);
      }
    } else if ($(window).scrollTop() < initialNavbarStartPos){
      if ($(".main-navbar").hasClass("now-sticky") == true) {


        $(".main-navbar").removeClass("now-sticky");
        //$(".boj").removeClass("now-sticky");

        $(".main-navbar").addClass("scrolled-back-to-top");
        //$(".boj").show();

      }
    } else if (winPos < initialNavbarEndPos + 350) {
      $("body>.bridge").show();
    }


  });
  $(window).trigger('scroll');
});

/*************  SUBNAV SET STICKY COMPACT  /*************/

$(function () {
  var subnav = $(".subnavigation");
  if (subnav.length === 0) {
    return;
  }

  var stickyOffset = 48;
  // Trigger subnav sticky 40px earlier in total.
  var revealAfter = -60;
  var subnavTop = 0;
  var subnavBottom = 0;
  var isSticky = false;

  var updateSubnavMetrics = function () {
    subnav.stop(true, true);
    subnav.removeClass("is-sticky");
    subnav.css("opacity", "");
    subnavTop = subnav.offset().top;
    subnavBottom = subnavTop + subnav.outerHeight();
    isSticky = false;
  };

  updateSubnavMetrics();
  $(window).on("resize", updateSubnavMetrics);

  $(window).on("scroll", function () {
    if (window.innerWidth <= 991) {
      if (isSticky) {
        subnav.stop(true, true);
        subnav.removeClass("is-sticky");
        subnav.css("opacity", "");
        isSticky = false;
      }
      return;
    }

    var winPos = $(window).scrollTop();
    var stickAt = subnavBottom + revealAfter - stickyOffset;
    var unstickAt = subnavBottom + revealAfter - stickyOffset - 55;

    if (!isSticky && winPos >= stickAt) {
      subnav.stop(true, true);
      subnav.css("opacity", "0");
      subnav.addClass("is-sticky");
      subnav.fadeTo(600, 1);
      isSticky = true;
    } else if (isSticky && winPos < unstickAt) {
      subnav.stop(true, true);
      subnav.removeClass("is-sticky");
      subnav.css("opacity", "");
      isSticky = false;
    }
  });

  $(window).trigger("scroll");
});






/*************  ADD SAFARI-MAC  /*************/



$(function() {
    // console.log(navigator.userAgent);
  /* Adjustments for Safari on Mac */
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      // console.log('Safari on Mac detected, applying class...');
      $('html').addClass('safari-mac'); // provide a class for the safari-mac specific css to filter with
  }
});




/*************  READ-MORE  /*************/


$(function() {
  $("section.type5 .read-more-or-less-link a").on("click", function () {
    var parent = $(this).closest(".wrapper");
    parent.find(".read-more-link").toggleClass("active");
    parent.find(".read-less-link").toggleClass("active");
    parent.find(".read-more-text").toggleClass("active");
    parent.find(".read-more-text").slideToggle(500, function () {});
    return false;
  });
});





/*************  PAUSE YOUTUBE VIDEO WHEN CLOSING MODAL  /*************/

$(function() {
  $(".modal.default").on('hidden.bs.modal', function (e) {
    $(".modal.default .video-responsive iframe").attr("src", $(".modal.default .video-responsive iframe").attr("src"));
  });
});





/*************  SUBSCRIBE  /*************/


$('.subscribe form#base').on("submit", function(event) {

  event.preventDefault();

  $(".subscribe form#base .btn").prop("disabled",true);
  var submitCision = false;
  var submitMailchimp = false;

  var english = $("#base-english").is(':checked');
  var swedish = $("#base-swedish").is(':checked');
  $("#mailchimp-lid").val("");

  //abort if no language
  if (english == false && swedish == false) {
    alert('At least one language must be selected');
    $(".subscribe form#base .btn").prop("disabled",false);
    return false;
  }




  // start set email
  $("#cision-email").val($("#base-email").val());
  $("#mailchimp-email").val($("#base-email").val());

    // start set lang cision
    if (english) {
      $("#lang_en").prop('checked', true);
    }
    if (swedish) {
      $("#lang_sv").prop('checked', true);
    }

    // start copy firstname, lastname and company and role to mailchimp
    $("#mailchimp-fname").val($("#base-fname").val());
    $("#mailchimp-lname").val($("#base-lname").val());
    $("#mailchimp-company").val($("#base-company").val());

    // start copy firstname and lastname to cision
    $("#cision-name").val($("#base-fname").val() + " " + $("#base-lname").val());


  // start set Cision reports
  if ($("#base-interim").is(':checked')) {
    $("#interim").prop('checked', true);
    submitCision = true;
  }
  if ( $("#base-annual").is(':checked')) {
    $("#annual").prop('checked', true);
    submitCision = true;
  }
  if ( $("#base-press").is(':checked')) {
    $("#press").prop('checked', true);
    submitCision = true;
  }

  // start set Mailchimp healtcare
  if ( $("#base-healthcare").is(':checked')) {
    if (english) {
      submitMailchimp = true;
      if ($("#mailchimp-lid").val() != "") {
        $("#mailchimp-lid").val($("#mailchimp-lid").val() + "|")
      }
      $("#mailchimp-lid").val($("#mailchimp-lid").val() + "21bf72c14f")
    }
    if (swedish) {
      submitMailchimp = true;
      if ($("#mailchimp-lid").val() != "") {
        $("#mailchimp-lid").val($("#mailchimp-lid").val() + "|")
      }
      $("#mailchimp-lid").val($("#mailchimp-lid").val() + "5744fb7608")
    }
  }

  // start set Mailchimp Professional
  if ( $("#base-professional").is(':checked')) {
    submitMailchimp = true;
    if ($("#mailchimp-lid").val() != "") {
      $("#mailchimp-lid").val($("#mailchimp-lid").val() + "|")
    }
    $("#mailchimp-lid").val($("#mailchimp-lid").val() + "f8d15adab6")
  }

  if (submitMailchimp == false && submitCision == false) {
    alert("At least one newsletter must be selected");
    $(".subscribe form#base .btn").prop("disabled",false);
    return false
  }
  if (submitMailchimp == true && submitCision == true) {
    console.log("Mailchimp and Cision");
    $.post('/', $('form#mailchimp').serialize())
    .done( function(data) {
      if (!data.success)
      {
        $(".subscribe form#base .btn").prop("disabled",false);
        alert("Sorry, something went wrong: Please try again later");
        alert(data.message);
      }
      else
      {
        $('form#cision').submit();
      }
    });
  } else if (submitMailchimp == true) {
    console.log("Mailchimp");

    $.post('/', $('form#mailchimp').serialize())
    .done( function(data) {
      if (!data.success)
      {
        $(".subscribe form#base .btn").prop("disabled",false);
        alert("Sorry, something went wrong: Please try again later");
        alert(data.message);
      }
      else
      {
        window.location = $("#mailchimp-redirect").val();
      }

    });
    $('form#mailchimp').submit();
  } else if (submitCision == true) {
    console.log("Cision");
    $('form#cision').submit();
  }

});

/*************  SAME HEIGHT  /*************/


$(function() {
  $(function() {
	  $('.match-height').matchHeight();
  });
});


/*************  CONTACT FORMS  /*************/



$(function() {
    $(".kind-of-info input[type='radio'][name='area']").on('click', function() {
      window.location = $(this).data("url");
  });
});


/*************  LOCAL FORM /*************/

$(function() {

  $('.local-form-wrapper form').submit(function(ev) {
    $('.local-form-wrapper .from-email').each(function () {
      $(this).val($(this).prev().val());
    });

    $('.local-form-wrapper form .btn').prop('disabled', true);

    // Prevent the form from actually submitting
    ev.preventDefault();

    var size = 0;
    $('.form-control.files').each(function () {
      var i;
      for (i = 0; i < this.files.length; i++) {
        size = size + this.files[i].size;
      }
    });
    if (size > 20971520) {
      $('.local-form-wrapper form .btn').prop('disabled', false);
      alert('Attachments size exceeds the allowable limit (20MB)');
      return false;
    }

    var formData = new FormData($(this)[0]);
    // Send it to the server
    $.ajax('/', {
      url:  '/',
      data: formData,
      type: 'POST',
      dataType: 'json',
      async: false,
      cache: false,
      contentType: false,
      processData: false,
      success: function(response) {
        $('.hide-when-submit').hide();
        $('#thanks').show();
        navigationFn.goToSection('#before-thanks');
      },
      error: function(response) {
        $('.local-form-wrapper form .btn').prop('disabled', false);
        alert('An error occurred...');
      }
    });
  });
});




$(function() {
  $('.local-form-wrapper .form-check-input.builder').click(function() {
    if (!$(this).is(':checked')) {
      console.log('dd');
      $(this).prev().prop("checked", true);
    } else {
      $(this).prev().prop("checked", false);
    }
  });
});

var navigationFn = {
  goToSection: function(id) {
      $('html, body').animate({
          scrollTop: $(id).offset().top
      }, 0);
  }
}

/*************  MOVE redirect-information-footer on top of cookie-warning if needed /*************/
$(function() {
  if ($(".redirect-information-footer").length) {
    var refreshIntervalId = setInterval(function(){
      if ($("#cookiescript_injected").length) {
        $("#cookiescript_injected").css("bottom", $(".redirect-information-footer").outerHeight() + "px");

        //$("#cookiescript_injected").css("padding-bottom", "50px");
      } else {
        $("#cookiescript_injected").css("bottom", "0");
        //$("#cookiescript_injected").css("padding-bottom", "10px");

      }
    }, 1000);
  }
});

/*************  LOAD YOUTUBE IN TOP MENU  /*************/

function initVidDefer() {
  var vidDefer = document.getElementsByClassName('youtube-defer');
  for (var i=0; i<vidDefer.length; i++) {
    if(vidDefer[i].getAttribute('data-src')) {
      vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
    }
  }
}
window.onload = initVidDefer;


/*************  Add video-container to iframe in type5  /*************/

$(function() {
  $('section.type5 .wrapper iframe:not(.google-maps)').each(function() {
    $(this).wrapAll('<div class="video-container"></div>');
  });
});



/*************  Open pdf:s in new window in desktops and tablets  /*************/

$(function() {
  if (screen.width > 700) {
    $('a[href$=".pdf"], a[href$=".docx"], a[href$=".xlsx"]').prop('target', '_blank');
  }
});


// Push boxes ------------------------------


$(function() {
  $( 'body' ).on( 'click', '.push-box', function( ) {
    var link = $(this).find("a");
    window.location = link.attr("href");

  });
});

/*************  Smooth scroll in subnav  /*************/


var scroll = new SmoothScroll('ul.subnav a[href*="#"]', {
	speed: 300,
  easing: 'Linear',
  speedAsDuration: true
});

document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll("#mc_embed_signup form");
  if (forms.length == 0) return

  for (const form of forms) {
    if (typeof form.action !== "string" || !form.action.startsWith("https://s4bio")) continue

    console.log("form")
    const ts = document.createElement('input')
    ts.type  = 'hidden'
    ts.name  = 'ts'
    ts.value = Date.now()
    form.appendChild(ts)

    const hp = document.createElement('input')
    hp.type  = 'text'
    hp.name  = 'data_check_8173'
    hp.style.display = 'none'
    form.appendChild(hp)

    form.addEventListener('submit', e => {
      const age = Date.now() - parseInt(ts.value, 10)
      const bot = age < 4000 || hp.value.trim() !== ''

      if (bot) {
        console.log("b")
        e.preventDefault()
        return false
      }

      console.log("nb")

      form.action = form.action.replace('s4bioservo', 'bioservo')
    });

  };
})
